import { type SalesMetricV2 } from "./types";

export function makeGoogleAllConversions(): SalesMetricV2 {
  const id = "googleAllConversions";
  const name = "Google All Conversion Events";

  return {
    id,
    name,
    fullName: name,
    description:
      "Google reported number of all conversion events (including purchases) across all channels",
    category: "google",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeGoogleConversions(): SalesMetricV2 {
  const id = "googleConversions";
  const name = "Google Purchases";

  return {
    id,
    name,
    fullName: name,
    description:
      "Google reported number of purchase conversions across all channels",
    category: "google",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeGoogleAllConversionsValue(): SalesMetricV2 {
  const id = "googleAllConversionsValue";
  const name = "Google All Conversion Events Revenue";

  return {
    id,
    name,
    fullName: name,
    description:
      "Google reported revenue from all conversions (including purchases) across all channels",
    category: "google",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeGoogleConversionsValue(): SalesMetricV2 {
  const id = "googleConversionsValue";
  const name = "Google Purchase Revenue";

  return {
    id,
    name,
    fullName: name,
    description:
      "Google reported revenue from all purchase conversions across all channels",
    category: "google",
    positiveTrend: "up",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeGoogleVideoViews(): SalesMetricV2 {
  const id = "googleVideoViews";
  const name = "Google video views";

  return {
    id,
    name,
    fullName: name,
    description: "Google reported video views",
    category: "google",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeGoogleClicks(): SalesMetricV2 {
  const id = "googleClicks";
  const name = "Google Clicks";

  return {
    id,
    name,
    fullName: name,
    description: "Google reported video views",
    category: "google",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeGoogleImpressions(): SalesMetricV2 {
  const id = "googleImpressions";
  const name = "Google Impressions";

  return {
    id,
    name,
    fullName: name,
    description:
      "An impression is counted whenever an item appears on the current page of results",
    category: "google",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeGoogleViewThroughConversions(): SalesMetricV2 {
  const id = "googleViewThroughConversions";
  const name = "Google view-through conversions";

  return {
    id,
    name,
    fullName: name,
    description:
      "Occur after an ad impression, if the user doesn't interact " +
      "with the ad, then later converts",
    category: "google",
    positiveTrend: "up",
    format: "integer",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeGoogleROAS(): SalesMetricV2 {
  const id = "googleROAS";
  const name = "Google ROAS";

  return {
    id,
    name,
    fullName: name,
    description:
      "Google reported ROAS, this is calculated by taking the total " +
      "revenue reported by Google and dividing by spend",
    category: "google",
    positiveTrend: "up",
    format: "multiplier",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeGoogleCAC(): SalesMetricV2 {
  const id = "googleCAC";
  const name = "Google CAC";

  return {
    id,
    name,
    fullName: name,
    description:
      "Calculated by taking the total spend reported by " +
      "Google and dividing by total number of purchases",
    category: "google",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeGoogleCostPerConversion(): SalesMetricV2 {
  const id = "googleCostPerConversion";
  const name = "Google cost per conversion";

  return {
    id,
    name,
    fullName: name,
    description:
      "Google reported cost per conversion, this is calculated by taking " +
      "spend and dividing by the number of total conversions reported by Google",
    category: "google",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}

export function makeGoogleAverageCPC(): SalesMetricV2 {
  const id = "googleAverageCPC";
  const name = "Google Average CPC";

  return {
    id,
    name,
    fullName: name,
    description:
      "Google reported average CPC, this is calculated by taking spend and " +
      "dividing by the number of total clicks reported by Google",
    category: "google",
    positiveTrend: "down",
    format: "dollars",
    getValue(metrics) {
      return metrics[id];
    },
  };
}
